import { SelectionDatePeriod, SelectionMetaEvent, SelectionPlace } from './internal';
export class SelectionEventsRecorded extends SelectionMetaEvent {
    getPlace() {
        return this.get("PLAC" /* Tag.Place */, null, SelectionPlace);
    }
    getDatePeriod() {
        return this.get("DATE" /* Tag.Date */, null, SelectionDatePeriod);
    }
}
//# sourceMappingURL=SelectionEventsRecorded.js.map